// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__rrFNj","selected":"Chip_selected__1VDLk"};